// import {useDispatch} from 'react-redux'

// import fetchData from './fetch-data'
import {getCookie, setCookie} from '../utils/cookie'
import activateGeolocateMobile from '../utils/activateGeolocateMobile'
// import isMobileDevice from './isMobileDevice'
// import useCoordsActions, {changeCoordsStateAction} from '../features/getCoords/actionCreators'

// export function useChangeCoordsState(state) {
//   const dispatch = useDispatch()
//   return () => {
//     dispatch(changeCoordsStateAction(state))
//   }
// }

async function getGeolocation() {
  let latitude
  let longitude
  try {
    // if (isMobileDevice()) {
    if (getCookie('lt') !== '' && getCookie('lt') !== 'true') {
      latitude = getCookie('lt')
      longitude = getCookie('lg')
      return {latitude, longitude}
    }
    const {lt, lg} = await activateGeolocateMobile()
    setCookie('lt', lt, 365)
    setCookie('lg', lg, 365)
    latitude = lt
    longitude = lg
    return {latitude, longitude}
  } catch (error) {
    console.debug(`catch error in getGeolocation by rejection: ${error}`)
    return {latitude: '', longitude: ''}
    // throw new Error(`catch error in getGeolocation: ${error}`)
  }
}

export default getGeolocation
